<script>
import headBox from "@/components/head.vue"
import footBox from "@/components/foot.vue"
import {getText} from "@/utils/text";

export default {
  components: {headBox, footBox},
  data() {
    return {}
  },
  mounted() {
    //滚动到顶部
    window.scrollTo(0, 0)
  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>


<template>
  <div>
    <headBox/>

    <section id="content" lang=ZH-CN style='tab-interval:21.0pt;word-wrap:break-word;text-justify-trim:
punctuation'>

      <div :class="$store.state.isPhone?'WordSection':'WordSection1'" style='layout-grid:15.6pt'>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:16.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>{{ getViewText('refund_policy') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>1. {{ getViewText('eligibility_for_refunds') }}<o:p></o:p></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>1.1 {{ getViewText('r_1') }}:<o:p></o:p></span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>-
{{ getViewText('r_2') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>-
{{ getViewText('r_3') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>1.2
{{ getViewText('r_4') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>2. {{ getViewText('refund_process') }}<o:p></o:p></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>2.1
{{ getViewText('r_5') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>2.2
{{ getViewText('r_6') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>2.3
{{ getViewText('r_7') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>3. {{ getViewText('refund_handling') }}<o:p></o:p></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>3.1
{{ getViewText('r_8') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>3.2
{{ getViewText('r_9') }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>4. {{ getViewText('cancellation_of_games') }}<o:p></o:p></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif;
'>{{ getViewText('r_10') }} </span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>5. {{ getViewText('additional_notes') }}<o:p></o:p></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>5.1
{{getViewText('r_11')}}<o:p></o:p></span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>5.2
{{getViewText('r_12')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>5.3
{{getViewText('r_13')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('r_14')}}<o:p></o:p></span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'><o:p>&nbsp;</o:p></span></p>

      </div>

    </section>

    <footBox/>
  </div>
</template>
<style>
.WordSection1 {
  margin-left: 105.0pt;
  margin-right: 105.0pt;
  color: #fff
}

.WordSection {
  margin-left: 50px;
  margin-right: 50px;
  color: #fff
}
</style>



// WEBPACK FOOTER //
// src/views/refundpolicy.vue